import { Component, Input } from '@angular/core';
import { PlatformService } from '@panamax/app-state';
import { OrderHeader, OrderItem } from '@usf/ngrx-order';
import { OrderExceptionService } from '@order/pages/order-exceptions/service/order-exception.service';
import { PanFeature } from 'src/environments/environment.features';
import {
  DisplayType,
  OrderStatusDetails,
} from '@shared/constants/order-status-title.enum';

@Component({
  selector: 'app-order-status-info',
  templateUrl: './order-status-info.component.html',
  styleUrls: ['./order-status-info.component.scss'],
})
export class OrderStatusInfoComponent {
  DisplayType = DisplayType;
  readonly PanFeature = PanFeature;
  @Input() orderHeader: OrderHeader;
  @Input() orderItems: OrderItem[];
  @Input() orderStatusDetails: OrderStatusDetails;
  @Input() title?: String;
  @Input() icon?: string;
  @Input() restrictToOG?: boolean;
  readonly orderStatusDetailsEnum = OrderStatusDetails;

  constructor(
    readonly platformService: PlatformService,
    readonly orderExceptionService: OrderExceptionService,
  ) {}

  navigateToOrderExceptions() {
    this.orderExceptionService?.navigateToResolveExceptionsPage(
      this.orderHeader,
    );
  }

  displayOrderStatusClass(): string {
    switch (this.orderStatusDetails?.displayType) {
      case DisplayType.DELIVERY_DELAYED:
      case DisplayType.ORDER_CANCELLED:
      case DisplayType.DELIVERY_ISSUE:
        return 'shipped-exception-info-status';
      default:
        return 'order-info-status';
    }
  }
  displayOrderStatusColor(): string {
    switch (this.orderStatusDetails?.displayType) {
      case DisplayType.DELIVERY_DELAYED:
      case DisplayType.ORDER_CANCELLED:
      case DisplayType.DELIVERY_ISSUE:
        return 'danger';
      default:
        return 'primary';
    }
  }
}
